import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import localePt from '@angular/common/locales/pt';
import { LOCALE_ID, provideBrowserGlobalErrorListeners } from '@angular/core';
import type { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideMenuConfig } from 'ng-primitives/menu';
import { provideTooltipConfig } from 'ng-primitives/tooltip';

import { routes } from './app.routes';
import { provideAnalytics } from './core/config/analytics';
import { apiRequestInterceptor } from './core/api/api-request.interceptor';
import { authSessionInterceptor } from './core/auth/auth-session.interceptor';

// App é pt-BR (index.html lang="pt-BR"). Registra o locale pt-BR para que os pipes
// date/number/currency do Angular formatem em pt-BR (ex.: "Criado em" 08/07/2026 22:38,
// R$ 1.234,50) em vez do fallback en-US.
registerLocaleData(localePt);

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(withInterceptors([apiRequestInterceptor, authSessionInterceptor])),
    provideRouter(routes),
    provideAnalytics(),
    provideMenuConfig({
      offset: 8,
      flip: true,
      shift: { padding: 12 },
      scrollBehavior: 'close',
    }),
    provideTooltipConfig({
      offset: 8,
      showDelay: 350,
      hideDelay: 80,
      flip: true,
      shift: { padding: 12 },
    }),
  ],
};
